import {
  BaseState,
  initializeBaseState,
  initializeBaseStateWithoutData,
} from '@app/core/store/_prototypes/action-reducers/state/base.state';

export interface LoadState<Key extends object, T> extends BaseState<T> {
  loading: boolean;
  // Loaded will either be false, or contain the object it loaded.
  loaded: false | Key;
  requested: Key;
}

export const initializeLoadStateWithoutData = <Key extends object, T>(): LoadState<Key, T> => ({
  loading: false,
  loaded: false,
  requested: null,
  ...initializeBaseStateWithoutData(),
});

export const initializeLoadState = <Key extends object, T>(data: T): LoadState<Key, T> => ({
  loading: false,
  loaded: false,
  requested: null,
  ...initializeBaseState(data),
});
